import { useCallback, useState, Dispatch, SetStateAction } from 'react'
import { UnitsList } from '../redux/slices/userSlice'

export const useUnits = (
    initialUnits: UnitsList[],
): {
    units: UnitsList[]
    setUnits: Dispatch<SetStateAction<UnitsList[]>>
    onChangeUnits: (id: string, selected: string) => void
    isUnitsUpdated: boolean
} => {
    const [units, setUnits] = useState<UnitsList[]>(initialUnits)
    const [isUnitsUpdated, setIsUnitsUpdated] = useState<boolean>(false)

    const onChangeUnits = useCallback((id: string, selected: string) => {
        setUnits((prev) => {
            return (
                prev?.map((i) => {
                    if (i.id === id) {
                        return { ...i, selected }
                    } else {
                        return i
                    }
                }) || []
            )
        })
        setIsUnitsUpdated(true)
    }, [])

    return { units, setUnits, onChangeUnits, isUnitsUpdated }
}
